
export function createErrorMessagesId({editorId, editorName}: Record<'editorId' | 'editorName', string>): string {
    return `${editorId}-${editorName}-errors`;
}